import { render, staticRenderFns } from "./unit_4.vue?vue&type=template&id=5b464f26&"
import script from "./unit_4.vue?vue&type=script&lang=ts&"
export * from "./unit_4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports